import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled(Typography.Header).attrs({
  $variant: '3',
})``;

export const Item = styled.div`
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  user-select: none;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.palette.secondary.border};
  }

  &:last-child {
    margin-bottom: 30px;
  }
`;
